import Lottie from 'lottie-react';
import soundWave from './sound-wave.json';

const SoundWave = () => {
  return <Lottie animationData={soundWave} autoPlay loop />;
};

export default SoundWave;
